import Vue from 'vue'

Vue.component('SendMessagePromptContent', {
  template: `
  <div>
    <div v-if="receiver">
      <h4>Send message to {{receiver.displayName}}</h4>
      <!-- <user-mini-avatar :user-id="receiverUserId" :show-name="true" size="32" /> -->
      <span
        class="avatar m-3 align-self-center"
        :style="{
          backgroundImage: 'url(&quot;' + $options.filters.defaultUserPic(receiver.profilePic) + '&quot;)'
        }" />
    </div>
    <el-input type="textarea" v-model="messageContent" placeholder="Type message...">
    </el-input>
  </div>
  `,
  beforeCreate() {
  },
  props: {
    receiver: {}
  },
  data: () => ({
    messageContent: '',
  }),
  methods: {
    reset() {
      this.messageContent = ''
    }
  }
})

export default {
  methods: {
    $send_msg_prompt({ receiverUserId = null }) {

      let receiver = null
      if ( receiverUserId ) {
        this.$api.contact_add_if_not_cached( receiverUserId );
        receiver = this.$models.userContact.get_contact_by_id( receiverUserId );
      }

      return new Promise((resolve, reject) => {
        this.$msgbox({
          title: receiver ? '' : 'Send message',
          message: this.$createElement(Vue.component('SendMessagePromptContent'), {
            props: { receiver: receiver }
          }),
          confirmButtonText: 'Send',
          showCancelButton: true,
          beforeClose: (action, instance, done) => {
            let done_with_reset = () => {
              done();
              dataContainer.reset();
            }

            if ( action !== 'confirm' ) {
              done_with_reset();
              reject(new Error('cancel'));
            }

            let dataContainer = instance.$children.find( child => 'messageContent' in child )
            if ( !dataContainer.messageContent ) {
              done_with_reset();
              reject(new Error('cancel'));
            }

            console.log("dataContainer", dataContainer)
            resolve({ done: done_with_reset, ...dataContainer.$data })
          }
        }).catch(e => e);
      });
    }
  }
}
